import classnames from 'classnames';

export default function Row({className, children, ...props}) {
  return (
    <div className={classnames('flex items-center', className)} {...props}>
      {children}
    </div>
  )
}
